import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
// import 'bootstrap/dist/css/bootstrap.css'
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import {
  currencyValues,
  getError,
  getSuccessMessage,
} from "../../store/helpers/common_functions";
import moment from "moment";
import {  Card, IconButton, Tab, Tabs, Box, Dialog, DialogContent, Typography, CircularProgress, Select, FormControl, InputLabel, MenuItem, CardActionArea, Avatar, Checkbox } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import Button from "@mui/material/Button";
import StatusLayout from "components/Status";
import CommentManager from "./CommentManager";
import { FaArrowLeft, FaClock, FaLevelUpAlt, FaMoneyBillWave, FaUserCog } from "react-icons/fa";
import a11yProps from "helpers/ay-props";
import TabPanel from "helpers/TabPanel";
import ProgramAssignment from "components/program/ProgramAssignment";
import WorklogManager from "./WorklogManager";
import ProgramAttachment from "components/program/ProgramAttachment";

import { Warning } from "@mui/icons-material";
import StyledBadge from "helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import { downloadUrl } from "Shared/commonFunction";
import { errorToast } from "helpers/Notification";
import { successToast } from "helpers/Notification";
import { Edit } from "@material-ui/icons";
import ProgramReport from "./ProgramReport";
import BasicMenu from "helpers/menu";
import { getMyLineManager } from "helpers/Common_functions";

function ProjectManagement({ location, SetSelectedMenu,systemSettings, FetchDetails, PutAction, loggedUser }) {
  const mainBackground = systemSettings?.mainBackground;

  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [count, setCount] = React.useState(0);
  const [commentOpen, setCommentOpen] = React.useState(false);
  const [info, setInfo] = useState(null);
  // const [value, setValue] = useState({});
  const [tabValue, setTabValue] = React.useState(0);
  const [totalLocated, setTotalLocated] = React.useState(0);
  const [type, setType] = React.useState(undefined);
  const [positions, setPositions] = React.useState([]);
  const [view, setView] = React.useState("all");
  const [search, setSearch] = React.useState();
  const [developers, setDevelopers] = React.useState([]);
  const [selectedDev, setSelectedDev] = React.useState([]);
  const [assigning, setAssigning] = React.useState(false);
  const [related, setRelated] = React.useState([]);
  const [lead, setLead] = React.useState(null);
  const [openAssign, setOpenAssign] = React.useState(false);
  const [progress, setProgress] = React.useState(false);
  const [status, setStatus] = React.useState(location.state?.program?.status);
  const [myLineManager, setMyLineManager] = useState([]);


  const [selected, setSelected] = React.useState(
    location.state?.status ?? "all"
  );
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [period, setPeriod] = React.useState({
    startDate: null,
    endDate: null,
  });
  const [currentYear, setCurrentYear] = React.useState(
    new Date().getFullYear()
  );
  const [expanded, setExpanded] = useState(false);
  const [descriptionDialogOpen, setDescriptionDialogOpen] = useState(false);


  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

    useEffect(() => {
      const getmyReportingLine = async () => {
        const myLineManager = await getMyLineManager(loggedUser);
        if (myLineManager) {
          setMyLineManager(myLineManager);
        }
      };
      getmyReportingLine();
    }, [loggedUser]);


  const history = useHistory();

  const [program, setProgram] = useState(location.state?.program);

  // console.log("program", program);


  const fetchProgramDetails = async () => {
    const response = await FetchDetails(`/api/program/details/${program?.id}`);
    // console.log("response", response);
    setInfo(response.data);
    setProgram({
      ...program,
      resource: response?.data?.data?.program?.resource,
      assignedTo: response?.data?.data?.program?.resource?.id,
      status: response?.data?.data?.program?.status,
    })
  };

  useEffect(() => {
    SetSelectedMenu({
      menu: "program",
      title: `Program Management > ${program?.name}`,
    });
    setSelected(location.state?.status ?? "all");
  }, [location.state]);

  useEffect(() => {
    fetchProgramDetails();
  }, []);

  useEffect(() => {
    if (open === 0) {
      loadRelated();
      loadPositions().then();
    }
  }, [openAssign]);

  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp.status) {
      const positionList = resp?.data?.list?.map((item) => ({ value: item.id, label: item.name }))
      setPositions([...positionList, { value: null, label: "Unclassified" }]);
    }
  }

  const loadRelated = async () => {
    const resp = await FetchDetails(`/api/project/related/dev/${program?.id}`);
    if (resp.status) {
      setRelated(resp.data.technologies);
      setDevelopers(resp.data.developers);
    }
  }

  const assignManager = async () => {
    if (!selectedDev.length) {
      errorToast("Select at least one team member !");
      return;
    }
    // if (!type) {
    //     errorToast("Select type of assignees !");
    //     return;
    // }
    setAssigning(true);
    const resp = await PutAction(`/api/program/assign/manager/${program?.id}`, { assignedTo: selectedDev[0] });
    if (resp.status) {

      await fetchProgramDetails();

      await onSuccess();
      successToast(getSuccessMessage(resp));
      setOpenAssign(false)
    } else {
      errorToast(getError(resp));
    }
    setAssigning(false);
  }


  const columns = [
    {
      name: "code",
      label: "Code",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "totalActivities",
      label: "Activities",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },

    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "id",
      label: "Budget",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const currentRow = list.find((x) => x.id === value);

          return <span className="text-[#A1A1A1] text-xs font-lighter">{
            currentRow?.budgetType === "non-restricted" ? currentRow?.allocatedBudget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : currentRow?.budget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }</span>
        },
      },
    },
    {
      name: "budgetType",
      label: "Budget Type",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    {
      name: "impact",
      label: "Impact",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    {
      name: "completionPercentage",
      label: "Performance",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{
            value
              ? `${parseFloat(value).toFixed(2)}%`
              : "0%"
          }</span>
        ),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status == 'to-verify' ? 'under-review' : status} />
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <BasicMenu onDetails={() =>    history.push(`/admin/project/details/${v}`, { program: program }) } onDelete={() => {
                            setId(v); setDeleteOpen(true)
                              }} onEdit={() => {
                                setId(v);
                                setValue({
                                  name: list.find((x) => x.id === v).name,
                                  code: list.find((x) => x.id === v).code,
                                  startDate: moment(list.find((x) => x.id === v).startDate).format("YYYY-MM-DD"),
                                  endDate: moment(list.find((x) => x.id === v).endDate).format("YYYY-MM-DD"),
                                  budget: list.find((x) => x.id === v).budget,
                                  expenses: list.find((x) => x.id === v).expenses,
                                  impact: list.find((x) => x.id === v).impact,
                                  perfomance: list.find((x) => x.id === v).perfomance,
                                  fundedBy: list.find((x) => x.id === v).fundedBy,
                                  division: list.find((x) => x.id === v).division,
                                  description: list.find((x) => x.id === v).description,
                                  currency: list.find((x) => x.id === v).currency,
                                  budgetType: list.find((x) => x.id === v).budgetType,
                                });
                                setOpen(2);
                               }} 
                            
                              
                               
                               />
     
        ),
      },
    },
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const onSuccess = () => setCount((v) => v + 1);

  const teamItem = (resource) => {
    const onClick = () => {

      if (value === 3) {
        setLead(resource);
        return;
      }

      if (selectedDev.filter(v => v === resource.id).length > 0) {
        setSelectedDev(old => old.filter(i => i !== resource.id));
      } else {
        setSelectedDev(old => [resource.id]);
      }
    };

    const isAll = view === 'all';

    let checked;

    if (value === 3) {
      checked = lead?.id === resource.id;
    } else {
      checked = selectedDev.filter(v => v === resource.id).length > 0;
    }

    return <div className={`mr-2 relative ${isAll ? 'mb-3' : ''}`}>
      <div className={'absolute right-0'} style={{ zIndex: "10", top: "-10px" }}>
        <Checkbox onChange={onClick} checked={checked} />
      </div>
      <CardActionArea onClick={onClick}>
        <StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        // variant="dot"
        >
          <Avatar
            sx={{ bgcolor: grey[300], width: 60, height: 60 }}
            alt={resource.names}
            src={resource.profile ? `${downloadUrl}/${resource.profile}` : undefined}
          />
        </StyledBadge>
        <div style={{ width: "130px" }}>
          <Typography sx={{
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
          }} variant={'body2'}>{resource.names}</Typography>
          <div>
            <Typography sx={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 1,
            }} variant={'subtitle2'} style={{ fontWeight: "bold" }}>{resource.category}</Typography>
          </div>
        </div>
      </CardActionArea>
    </div>
  }

  const filterFunction = (v) => {
    const lower = search?.toLowerCase();
    const searchCondition = !search || v.names?.toLowerCase()?.includes(lower) || v.category?.toLowerCase()?.includes(lower);

    return searchCondition && (type === v.positionId || type === undefined);
  }

  const selectPositionView = <FormControl fullWidth size={view ? 'small' : 'medium'}>
    <InputLabel id="demo-simple-select-label">Select Position</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={type}
      label="Select Position"
      onChange={e => {
        const val = e.target.value;
        if (val === "" || val === undefined) {
          setType(undefined);
        } else {
          setType(val);
        }
      }}
    >
      <MenuItem value={undefined}>--- All Positions ---</MenuItem>
      {positions?.map(v => <MenuItem value={v.value}>{v.label}</MenuItem>)}
    </Select>
  </FormControl>;

  const viewControl = <div className="grid grid-cols-2 gap-2">
    {selectPositionView}
    <FormControl fullWidth size={view ? 'small' : 'medium'}>
      <InputLabel id="demo-simple-select-label">Select View</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={view}
        label="Select View"
        onChange={e => setView(e.target.value)}
      >
        {/* {viewItems.map(v => <MenuItem value={v.value}>{v.label}</MenuItem>)} */}
      </Select>
    </FormControl>
  </div>

  const searchView =
    <div className={'grid grid-cols-2 gap-2'}>
      {selectPositionView}
      <div className={'flex'}>

        <input value={search} onChange={e => setSearch(e.target.value)} placeholder={'Search here ...'} type={'text'} className={'px-2 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150'} />

      </div>

    </div>;

  return (
    <div className="w-full px-4">
      <div className=" flex flex-col gap-4 justify-start items-start">
        <div className="w-full">
          <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm flex flex-col gap-4">
            <div onClick={
              // go back  with history without 
              () => history.goBack()
            } className="text-gray-500 flex items-center gap-2">
              <FaArrowLeft />
              <span className=" font-semibold ">{program?.name}</span>
            </div>
            <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm  ">
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-2 flex flex-col gap-6 justify-around">
                  <div className="">
                    <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                      <FaClock /> Program Start-End Date
                    </p>
                    <p className="font-semibold text-[13px]">
                      {moment(program?.startDate).format("DD/MM/yyyy")} -{" "}
                      {moment(program?.endDate).format("DD/MM/yyyy")}
                    </p>
                    <div>
                      <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                        <FaClock /> Program Duration
                      </p>
                      <p className="font-semibold text-[13px]">
                        {
                          moment(program?.endDate).diff(moment(program?.startDate), "months") + " months"

                        }
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 ">
                    <div className="space-y-2">
                      <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                        <FaMoneyBillWave /> Budget
                      </p>
                      <p className="font-semibold text-[13px]">
                        {program?.totalBudget?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </p>
                    </div>
                    <div className="space-y-2 font-light">
                      <p className="text-gray-500 flex items-center gap-2 text-[14px]">
                        <FaMoneyBillWave /> Used
                      </p>
                      <p className="font-semibold text-[13px]">
                        {totalLocated?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? "0"}
                      </p>
                    </div>
                    <div className="space-y-2 font-light">
                      <p className="text-gray-500 flex items-center gap-2 text-[14px]">
                        <FaMoneyBillWave /> Balance
                      </p>
                      <p className="font-semibold text-[13px]">
                        {
                          (parseInt(program?.totalBudget) - totalLocated)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? "0"
                        }
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-2 flex flex-col gap-6 justify-around">
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                      <div>
                        <p className="text-gray-500 font-light text-[14px]">Program Status</p>
                        <StatusLayout status={program?.status == 'to-verify' ? 'under-review' : program?.status} />
                      </div>
                      <IconButton
                        onClick={() => {
                          setProgress(true);
                        }}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <Edit />
                      </IconButton>
                    </div>
                    <div>
                      <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                        <FaLevelUpAlt /> Program Perfomance
                      </p>
                      <p className="font-semibold text-[13px]">
                        {
                          program?.completionPercentage ? `${parseFloat(program?.completionPercentage).toFixed(2)}%` : "0%"
                        }
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                      <FaUserCog /> Program Manager
                    </p>
                    {
                      program?.assignedTo === null ? (
                        <Button
                          variant="outlined"
                          className="text-gray-500 border-gray-500 hover:bg-gray-500 hover:text-white"
                          onClick={() => {
                            setOpenAssign(true);
                          }}
                        >
                          Assign
                        </Button>
                      ) : (
                        <div className="flex items-center gap-2">
                          <span className="font-semibold">{program?.resource?.names ?? 'N/A'}</span>
                          <Button
                            variant="outlined"
                            className="text-gray-500 border-gray-500 hover:bg-gray-500 hover:text-white"
                            sx={{
                              height: "25px",
                              width: "5px"
                            }}
                            onClick={() => {
                              setOpenAssign(true);
                            }}
                          >
                            <Edit

                              style={
                                {
                                  fontSize: "15px",


                                }
                              } />
                          </Button>
                        </div>
                      )
                    }
                  </div>
                </div>

                <div className="space-y-2">
                  <p className="text-gray-700 font-semibold text-[14.92px]">Description</p>
                  <div className="text-gray-600 font-normal text-sm">
                    {program?.description?.length > 100 ? (
                      <>
                        {program?.description?.substring(0, 100)}...
                        <Button
                          size="small"
                          onClick={() => setDescriptionDialogOpen(true)}
                          sx={{
                            textTransform: 'none',
                            color: mainBackground,
                            '&:hover': {
                              backgroundColor: 'transparent',
                              textDecoration: 'underline'
                            }
                          }}
                        >
                          View more
                        </Button>
                      </>
                    ) : (
                      program?.description
                    )}
                  </div>
                </div>


              </div>

            </div>
          </div>
        </div>

        <DeleteDialog
          open={progress}
          setOpen={() => {
            setProgress(false);
          }}
          onSuccess={async () => {
            await fetchProgramDetails();
          }}
          info={true}
          title={"Progress Status"}
          bodyText={
            <div className={"py-3 text-left"}>
              <FormControl fullWidth={true} size={"small"}>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value={"incoming"}>incoming</MenuItem>

                  <MenuItem value={'in-progress'}>In Progress</MenuItem>
                  <MenuItem value={'to-verify'}>Under Review</MenuItem>
                  <MenuItem value={'on-hold'}>On Hold</MenuItem>
                  <MenuItem value={'completed'}>Completed</MenuItem>

                </Select>

              </FormControl>
            </div>
          }
          url={`/api/program/change-status/${program?.id}?status=${status}`}
        />

        <Dialog open={openAssign} onClose={() => setOpenAssign(false)} maxWidth={'md'} fullWidth={true}>
          <DialogContent>
            <div className={'flex flex-col text-center justify-between'} style={{ minHeight: "70vh" }}>
              <div className={'text-center'}>
                <div className={'justify-center mb-3'}>
                  <Typography variant={'h4'}>Assign Program Manager</Typography>
                </div>
              </div>
              <div>
                {!view ? viewControl : view === 'all' ? <div>
                  <div className={'mb-5'}>
                    {searchView}
                  </div>
                  <div className={'flex flex-wrap'}>
                    {developers.filter(filterFunction).map(v => teamItem(v))}
                  </div>

                </div> : <div>
                  {searchView}
                  {related.map(v => {
                    const filter = v.Technology.ResourceTechnologies.map(v => v.Resource).filter(filterFunction);
                    return <div>
                      <div className={'text-left'}><Typography variant={'h6'}>{v.Technology.name}</Typography></div>
                      <div className={'mt-3 mb-3'}>
                        <Card>
                          <div>
                            {filter.length ? <div style={{ overflowX: 'auto' }} className={'flex p-3'}>
                              {filter.map(resource => {
                                return teamItem(resource);
                              })}
                            </div> : <div className={'p-5'}>
                              <Warning style={{ fontSize: "40px" }} />
                              <div>No Team members found !</div>
                            </div>}
                          </div>
                        </Card>
                      </div>
                    </div>;
                  })}
                </div>}
              </div>
              <div>
                {assigning ? <CircularProgress /> : <>
                  <div><Button onClick={assignManager} sx={{
                    padding: "10px",
                    paddingX: "20px",
                    backgroundColor: mainBackground,
                    color: 'white',
                    '&:hover': {
                      backgroundColor: mainBackground,
                    },
                  }} variant={'contained'}>Assign</Button></div>
                </>
                }
              </div>
            </div>
          </DialogContent>
        </Dialog>

        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          onSuccess={onSuccess}
          url={`/api/project/delete/${id}`}
        />
        <CommentManager
          projectId={id}
          project={""}
          open={commentOpen}
          setOpen={() => setCommentOpen(false)}
          onClose={() => {
            setCommentOpen(false);
          }}
          onSuccess={onSuccess}
        />

        <FormDialog
          maxWidth={"md"}
          col={6}
          open={open > 0}
          onSuccess={onSuccess}
          setOpen={setOpen}
          url={open === 1 ? "/api/project/create" : `/api/project/update/${id}`}
          title={open === 1 ? "Create New Project" : "Edit Project"}
          fields={[
            {
              name: "name",
              label: "Project Name",
              value: value["name"],
              required: true,
              setValue: (val) => setValue0("name", val),
            },
            {
              name: "code",
              label: "Code",
              value: value["code"],
              required: true,
              setValue: (val) => setValue0("code", val),
            },
            {
              name: "startDate",
              label: "Start Date",
              type: "date",
              value: value["startDate"],
              required: true,
              setValue: (val) => setValue0("startDate", val),
            },
            {
              name: "endDate",
              label: "End Date",
              type: "date",
              value: value["endDate"],
              required: true,
              setValue: (val) => setValue0("endDate", val),
            },
            {
              name: "budgetType",
              label: "Budget Type",
              value: value["budgetType"],
              type: "radio",
              values: [
                { label: "Restricted", value: "restricted" },
                { label: "Non Restricted", value: "non-restricted" },

              ],
              required: true,
              col: 12,
              setValue: (val) => {
                if (val === "non-restricted") {
                  setValue0("budget", 0);
                } else {
                  setValue0("budget", 0);
                }
                setValue0("budgetType", val);

              }

            },
            {
              name: "budget",
              label: "Budget",
              value: value["budget"],
              type: value["budgetType"] === "non-restricted" ? "text" : "number",
              isNumber: true,
              hidden: value["budgetType"] === "non-restricted",
              disabled: value["budgetType"] === "non-restricted",
              setValue: (val) => {
                setValue0("budget", val);
              },
            },
            {
              name: "expenses",
              label: "Expenditure",
              value: value["expenses"],
              type: "number",
              hidden: true,
              isNumber: true,
              setValue: (val) => setValue0("expenses", val),
            },
            {
              name: "impact",
              label: "Impact",
              value: value["impact"],
              type: "select",
              values: [
                { label: "Low", value: "low" },
                { label: "Medium", value: "medium" },
                { label: "High", value: "high" },
              ],
              required: true,
              setValue: (val) => setValue0("impact", val),
            },
            // {
            //   name: "performance",
            //   label: "Perfomance",
            //   value: value["performance"],
            //   type: "number",
            //   setValue: (val) => setValue0("performance", val),
            // },

            {
              name: "fundedBy",
              label: "Funder",
              value: "test",
              hidden: true,
              required: false,
              type: "text",
              setValue: (val) => setValue0("fundedBy", val),
            },
            {
              name: "programId",
              label: "Program",
              value: program?.id,
              required: false,
              type: "text",
              hidden: true,
              setValue: (val) => setValue0("programId", val)
            },

            {
              name: "currency",
              label: "Currency",
              value: value["currency"],
              type: "select",
              values: currencyValues,
              required: true,
              setValue: (val) => setValue0("currency", val),

            },
            {
              name: "description",
              label: "Project Description",
              value: value["description"],
              required: false,
              type: "textarea",
              col: 12,
              setValue: (val) => setValue0("description", val),
            },
          ]}
        />

        <Dialog
          open={descriptionDialogOpen}
          onClose={() => setDescriptionDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogContent>
            <div className={"flex items-center"}>
              <div className={"flex-grow font-bold text-lg"}>
                <Typography variant="h6" className="mb-3">Program Description</Typography>
              </div>
              <IconButton onClick={
                () => {
                  setDescriptionDialogOpen(false);
                }
              }>
                <img
                  src={require("assets/icons/close.svg").default}
                  alt={"close"}
                />
              </IconButton>
            </div>
            <Typography variant="body1">
              {program?.description}
            </Typography>
          </DialogContent>
        </Dialog>

        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleChange} aria-label="program tabs"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              sx={{
                "& button.Mui-selected": {
                  color: mainBackground,
                  borderBottom: `2px solid ${mainBackground}`,
                },
                " .MuiTabs-indicator": {
                  backgroundColor: mainBackground,
                },

              }}
            >
              <Tab label="Projects" {...a11yProps(0)} />
              {/* <Tab label="Funders" {...a11yProps(1)} /> */}
              {/* <Tab label="Partners" {...a11yProps(2)} /> */}
              <Tab label="Assigned" {...a11yProps(3)} />
              <Tab label="Program Documents" {...a11yProps(1)} />
              {/* <Tab label="Meetings" {...a11yProps(5)} /> */}
              {/* <Tab label="History" {...a11yProps(6)} /> */}
              <Tab label="Worklogs" {...a11yProps(2)} />
              {/* <Tab label="Contribution" {...a11yProps(8)} /> */}
              <Tab  label="Report" {...a11yProps(3)} />
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0}>
            <DatatableComponent

              order={location.state?.order}
              onRowClick={(data, { rowIndex }) => {
                history.push(`/admin/project/details/${list[rowIndex].id}`,  { program: program });
              }}
              onAddNew={() => {
                setOpen(1);
                setValue0("budgetType", "non-restricted");
                setValue0("budget", 0);
                setValue0("currency", "rwf");
              }
              }
              processData={(data) => {
                setList(data.data);
                let total = 0;
                for (let i = 0; i < data.data.length; i++) {
                  total += parseInt(data.data[i].totalAllocated ?? 0);
                }
                setTotalLocated(total);
                return data;
              }}
              onRowSelectionChange={(list) => { }}
              search={false}
              searchfield={true}
              viewColumns={false}
              elevation={1}
              pdf={false}
              excel={false}
              columns={columns}
              url={`/api/project/list?status=${selected}&count=${count}&startDate=${period.startDate}&endDate=${period.endDate}&programId=${program?.id}`}
            />
          </TabPanel>
          {/* 
          <TabPanel value={tabValue} index={1}>
            <FunderAssignment program={program} info={info} onSuccess={fetchProgramDetails} />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <PartnerAssegnment program={program} info={info} onSuccess={fetchProgramDetails} />
          </TabPanel> */}



          <TabPanel value={tabValue} index={1}>
            <ProgramAssignment info={info} onSuccess={fetchProgramDetails} />
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <ProgramAttachment info={info?.data} onSuccess={fetchProgramDetails} canEdit={true} />
          </TabPanel>

          <TabPanel value={tabValue} index={3}>
            <WorklogManager inline={true} program={program} open={true} setOpen={() => false} canViewAll={true} />
          </TabPanel>

          <TabPanel value={tabValue} index={4}>
            <ProgramReport linemanager = {myLineManager} resourceId={loggedUser?.Resource.id} program={program} programId={program?.id} onSuccess={fetchProgramDetails} canEdit={true} />
          </TabPanel>

        </Box>


      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManagement);
